<template>
  <div class="input-area">
    <active-member
      v-bind:conversationId="conversationId"
      v-bind:memberId="memberId">
    </active-member>
    <input type="text" maxlength=49 autofocus autocapitalize="off"
      v-model="text"
      v-on:input="checkTextOnInput"
      v-on:keydown.enter="checkTextOnEnter"
      />
  </div>
</template>

<script>
import { db, FieldValue } from '../db';
import ActiveMember from './ActiveMember';

export default {
    name: 'InputArea',

    props: {
        conversationId: String,
        memberId: String
    },

    components: {
        ActiveMember
    },

    data() {
        return {
            text: ''
        }
    },

    methods: {
        checkTextOnInput: function() {
            const trailingWhitespaceRx = /\s$/
            if (trailingWhitespaceRx.test(this.text)) {
                const firstWordRx = /^\s*\S+/
                const firstWordMatch = firstWordRx.exec(this.text);
                if (firstWordMatch) {
                    const firstWord = firstWordMatch[0];
                    this.saveWord(firstWord);
                    this.text = '';
                }
            }
        },

        checkTextOnEnter: function() {
            //TODO refactor duplicate logic
            const firstWordRx = /^\s*\S+/
            const firstWordMatch = firstWordRx.exec(this.text);
            if (firstWordMatch) {
                const firstWord = firstWordMatch[0];
                this.saveWord(firstWord);
                this.text = '';
            }
        },

        saveWord: function(text) {
            const conversation = db.collection('conversations').doc(this.conversationId)
            const member = conversation.collection('members').doc(this.memberId);
            const timestamp = FieldValue.serverTimestamp();
            member.collection('words').add({ text, timestamp });
        }
    }
}
</script>

<style scoped>
.input-area {
    position: absolute;
    bottom: 0;
    padding: 10px;
}
input {
    width: 100%;
    padding: 10px;
    border-radius: 10px;
    outline: none;
    font-size: 24px;
    border: 1px solid #6d547e;
}
</style>